<div class="flex flex-wrap">
    <div class="w-full md:w-9/12 flex flex-wrap p-5" *ngIf="view.images">
        <ng-container *ngFor="let item of view.images">
            <div class="text-center w-full md:w-3/12">
                <a href="javascript:void(0)" (click)="this.purpose == 'select' ? selectImage(item) : toggleActiveImage(item)" class="block" ngbTooltip="Click to toggle active state">
                    <div class="relative" *ngIf="item.isFeatured">
                        <div class="absolute top-0 left-0 bg-blue-500 text-white px-2 py-1 text-sm">#1</div>
                    </div>
                    <div class="w-full h-[15vh] bg-center bg-cover" [style.background-image]="item.urlBg" [class.opacity-50]="!item.isActive"></div>
                </a>
                <div class="flex mt-2">
                    <div class="w-1/2 text-left">
                        <small>
                            <a href="javascript:void(0)" (click)="toggleFeaturedImage(item)" class="text-blue-500 hover:text-blue-700">Set as featured</a>
                        </small>
                    </div>
                    <div class="w-1/2 text-right">
                        <small>
                            <a href="javascript:void(0)" (click)="removeImage(item)" class="text-red-500 hover:text-red-700">Remove</a>
                        </small>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="pt-4 w-full ">
        <div class="border-2 border-dashed border-blue-400 bg-blue-50 rounded-lg p-4" [dropzone]="config" (init)="onUploadInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
            <div class="text-center">
                <i class="fas fa-cloud-upload-alt text-blue-500 text-2xl"></i>
                <h6 class="mt-2 text-blue-700">{{description}}</h6>
            </div>
        </div>
        <!-- <ngx-dropzone (init)="onUploadInit($event)" (error)="onUploadError($event)" (success)="onUploadSuccess($event)">
            <ngx-dropzone-label>
                <div class="text-center w-full p-6">
                    <i class="fas fa-cloud-upload-alt text-blue-500 text-2xl"></i>
                    <h6 class="mt-2 text-gray-500">{{description}}</h6>
                </div>
            </ngx-dropzone-label>
        </ngx-dropzone> -->
        
    </div>
</div>